import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/linkPwa.css';

export default function LinkCustomerPwaPage() {
  const { orderId = '' } = useParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(orderId || '');
  const cleanOrderId = useMemo(() => String(orderId || '').trim(), [orderId]);

  const openOrder = (event) => {
    event?.preventDefault?.();
    const next = String(token || '').trim();
    if (next) navigate(`/track/${encodeURIComponent(next)}`);
  };

  return (
    <div className="link-pwa-screen link-pwa-centered">
      <section className="link-pwa-login-card">
        <div className="link-pwa-login-top">
          <div>
            <div className="link-pwa-logo">Link<span>.</span></div>
            <div className="link-pwa-kicker">Customer Tracking</div>
          </div>
        </div>

        <h1>{cleanOrderId ? 'Track your order.' : 'Open your order.'}</h1>
        <p className="link-pwa-note">
          {cleanOrderId
            ? `Tracking link loaded for ${cleanOrderId}. Live customer status, approval and ETA will connect here next.`
            : 'Paste an order number or customer token to open the customer tracking page.'}
        </p>

        <form onSubmit={openOrder} className="link-pwa-unlock-card">
          <label>Order tracking link</label>
          <input value={token} onChange={(event) => setToken(event.target.value)} placeholder="Order number or token" />
          <button type="submit">Open tracking</button>
        </form>
      </section>
    </div>
  );
}
